const ARABIC_INDIC_ZERO = 0x0660;
const EASTERN_INDIC_ZERO = 0x06F0;

export function normalizeIndicDigits(value) {
  return String(value ?? '').replace(/[٠-٩۰-۹]/g, (character) => {
    const code = character.charCodeAt(0);
    if (code >= ARABIC_INDIC_ZERO && code <= ARABIC_INDIC_ZERO + 9) {
      return String(code - ARABIC_INDIC_ZERO);
    }
    if (code >= EASTERN_INDIC_ZERO && code <= EASTERN_INDIC_ZERO + 9) {
      return String(code - EASTERN_INDIC_ZERO);
    }
    return character;
  });
}

export function extractDigits(value, maxLength) {
  const digits = normalizeIndicDigits(value).replace(/\D/g, '');
  if (maxLength == null) {
    return digits;
  }
  return digits.slice(0, Number(maxLength) || 0);
}
